/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Checkin_Confirm_FailInputs */

const en_rental_checkin_confirm_fail = /** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to confirm check-in. Please try again.`)
};

const es_rental_checkin_confirm_fail = /** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al confirmar el check-in. Por favor, inténtalo de nuevo.`)
};

const fr_rental_checkin_confirm_fail = /** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la confirmation de l'arrivée. Veuillez réessayer.`)
};

const de_rental_checkin_confirm_fail = /** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Bestätigen des Check-ins. Bitte versuche es erneut.`)
};

const id_rental_checkin_confirm_fail = /** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal mengonfirmasi check-in. Silakan coba lagi.`)
};

/** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */
const ja_rental_checkin_confirm_fail = en_rental_checkin_confirm_fail;

/** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */
const zh_rental_checkin_confirm_fail = en_rental_checkin_confirm_fail;

/** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */
const ar_rental_checkin_confirm_fail = en_rental_checkin_confirm_fail;

/** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */
const it_rental_checkin_confirm_fail = en_rental_checkin_confirm_fail;

/** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */
const ru_rental_checkin_confirm_fail = en_rental_checkin_confirm_fail;

/** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */
const pt_rental_checkin_confirm_fail = en_rental_checkin_confirm_fail;

/** @type {(inputs: Rental_Checkin_Confirm_FailInputs) => LocalizedString} */
const ko_rental_checkin_confirm_fail = en_rental_checkin_confirm_fail;

/**
* | output |
* | --- |
* | "Failed to confirm check-in. Please try again." |
*
* @param {Rental_Checkin_Confirm_FailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_checkin_confirm_fail = /** @type {((inputs?: Rental_Checkin_Confirm_FailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Checkin_Confirm_FailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_checkin_confirm_fail(inputs)
	if (locale === "es") return es_rental_checkin_confirm_fail(inputs)
	if (locale === "fr") return fr_rental_checkin_confirm_fail(inputs)
	if (locale === "de") return de_rental_checkin_confirm_fail(inputs)
	if (locale === "ja") return ja_rental_checkin_confirm_fail(inputs)
	if (locale === "zh") return zh_rental_checkin_confirm_fail(inputs)
	if (locale === "ar") return ar_rental_checkin_confirm_fail(inputs)
	if (locale === "id") return id_rental_checkin_confirm_fail(inputs)
	if (locale === "it") return it_rental_checkin_confirm_fail(inputs)
	if (locale === "ru") return ru_rental_checkin_confirm_fail(inputs)
	if (locale === "pt") return pt_rental_checkin_confirm_fail(inputs)
	return ko_rental_checkin_confirm_fail(inputs)
});